import { i18n, ILanguageRsp, requestPlatform } from '@tencent/vb-web-base';
import { getServerTime, to } from '@tencent/vb-web-base-core';
import { NetworkError } from '@common/lib/error';
import {
  ICheckCarOwnerInfoData,
  ICheckLoanStatusReq,
  ICheckCarOwnerRightReq,
  ICheckLoanStatusResp,
  ICheckNoTeslaWhiteAndIsElectricCarResp,
  ICheckTeslaWhiteAndOwnerInfoData,
  IRegisterPinRespData,
  IRightActDate,
  IRightItem,
  ITeslaRegisterPageConfigData,
} from '@common/core/interface/IModel';

interface ITSelectOption {
  key: string;
  value: string;
  label: string;
}
interface IBrandListData {
  list: ITSelectOption[];
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export async function teslaNameListRegisterWeb(
  rn: string,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  area_code: string,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  phone_number: string,
  captcha: string,
  lang: string,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  accept_msg_mark: number,
) {
  const { getT } = i18n;
  const $t = getT();
  rn = rn.toLocaleUpperCase();
  const [respData, err] = await to(
    requestPlatform<{
      [x: string]: any;
      data: {
        whitelist_business_id: string;
      }
      code: number;
      message: string;
    }>('/java/loan/namelist/registerRnH5', 'POST', {
      rn,
      source: 'teslaNameListRegister',
      area_code,
      phone_number,
      captcha,
      lang,
      accept_msg_mark,
    }),
  );
  if (err) {
    throw new NetworkError({
      code: err?.status,
      message: $t('系统繁忙，请稍后重试'),
      tag: 'registerError',
    });
  }
  const { code } = respData;
  if (code !== 0) {
    throw new NetworkError({ code, message: respData.message, tag: 'registerProblem' });
  }
  return respData.data;
}

export async function teslaPinRegisterWeb(
  pin: string,
  businessType: number,
  whiteListType: number,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  area_code: string,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  phone_number: string,
  captcha: string,
  lang: string,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  accept_msg_mark: number,
): Promise<IRegisterPinRespData> {
  const { getT } = i18n;
  const $t = getT();
  pin = pin.toLocaleUpperCase();
  const [respData, err] = await to(
    requestPlatform<{
      code: number;
      message: string;
      data: IRegisterPinRespData;
    }>('/java/loan/namelist/registerVehicleH5', 'POST', {
      vehicle_no: pin,
      vehicle_brand_no: 'Tesla',
      source: 'teslaPinRegister',
      business_type: businessType,
      whitelist_type: whiteListType,
      accept_msg_mark,
      area_code,
      phone_number,
      captcha,
      lang,
    }),
  );
  if (err) {
    throw new NetworkError({
      code: err?.status,
      message: $t('系统繁忙，请稍后重试'),
      tag: 'registerError',
    });
  }
  const { code } = respData;
  if (code !== 0) {
    throw new NetworkError({ code, message: respData.message, tag: 'registerProblem' });
  }
  return respData.data;
}

export async function teslaNameListRegister(rn: string, inviteCode?: string) {
  const { getT } = i18n;
  const $t = getT();
  rn = rn.toLocaleUpperCase();
  const [respData, err] = await to(
    requestPlatform<{
      code: number;
      message: string;
      data: IRegisterPinRespData;
    }>('/java/loan/namelist/registerRnApp', 'POST', { rn, source: 'teslaNameListRegister', invitation_code: inviteCode?.toLocaleUpperCase() }),
  );
  if (err) {
    throw new NetworkError({
      code: err?.status,
      message: $t('系统繁忙，请稍后重试'),
      tag: 'registerError',
    });
  }
  const { code } = respData;
  if (code !== 0) {
    throw new NetworkError({ code, message: respData.message, tag: 'registerProblem' });
  }
  return respData.data;
}

export async function pinRegister(
  pin: string,
  businessType: number,
  whiteListType: number,
  brandId: string,
  inviteCode?: string,
): Promise<IRegisterPinRespData> {
  const { getT } = i18n;
  const $t = getT();
  pin = pin.toLocaleUpperCase();
  const [respData, err] = await to(
    requestPlatform<{
      code: number;
      message: string;
      data: IRegisterPinRespData;
    }>('/java/loan/namelist/registerVehicleApp', 'POST', {
      vehicle_no: pin,
      vehicle_brand_no: brandId,
      source: 'pinRegister',
      business_type: businessType,
      whitelist_type: whiteListType,
      invitation_code: inviteCode,
    }),
  );
  if (err) {
    throw new NetworkError({
      code: err?.status,
      message: $t('系统繁忙，请稍后重试'),
      tag: 'registerError',
    });
  }
  const { code } = respData;
  if (code !== 0) {
    throw new NetworkError({ code, message: respData.message, tag: 'registerProblem' });

  }
  return respData.data;
}
export async function checkCarOwnerInfo(businessType: number, whiteListType: number) {
  const { getT } = i18n;
  const $t = getT();
  const [respData, err] = await to(
    requestPlatform<{
      code: number;
      message: string;
      data: ICheckCarOwnerInfoData;
    }>('/node/loan/carOwner/checkCarOwnerInfo', 'GET', { businessType, whiteListType }),
  );
  if (err) {
    throw new NetworkError({
      code: err?.status,
      message: $t('系统繁忙，请稍后重试'),
      tag: 'checkCarOwnerInfoError',
    });
  }
  const { code } = respData;
  if (code !== 0) {
    throw new NetworkError({ code, message: respData.message, tag: 'checkCarOwnerInfoProblem' });
  }
  return respData.data;
}

// 获取车主专区活动时间
export async function GetRightActDate(brand: string): Promise<IRightActDate> {
  const { getT } = i18n;
  const $t = getT();
  const [respData, err] = await to(
    requestPlatform<{
      code: number;
      message: string;
      data: IRightActDate;
    }>('/node/loan/carOwnerRight/getActDate', 'GET', { brand }),
  );
  if (err) {
    throw new NetworkError({
      code: err.status,
      message: $t('系统繁忙，请稍后重试'),
      tag: 'getRightActDateError',
    });
  }
  const { code, message, data } = respData;
  if (code !== 0) {
    throw new NetworkError({ code, message, tag: 'getRightActDateError' });
  }
  return data;
}

// 获取车主专区权益列表
export async function GetRightList(brand: string): Promise<IRightItem[]> {
  const { getT } = i18n;
  const $t = getT();
  const [respData, err] = await to(
    requestPlatform<{
      code: number;
      message: string;
      data: IRightItem[];
    }>('/node/loan/carOwnerRight/getRightList', 'GET', { brand }),
  );
  if (err) {
    throw new NetworkError({
      code: err.status,
      message: $t('系统繁忙，请稍后重试'),
      tag: 'getRightListError',
    });
  }
  const { code, message, data } = respData;
  if (code !== 0) {
    throw new NetworkError({ code, message, tag: 'getRightListError' });
  }
  return data;
}

// 获取tesla预登记页面配置
export async function GetTeslaRegisterPageConfig(): Promise<ITeslaRegisterPageConfigData> {
  const { getT } = i18n;
  const $t = getT();
  const [respData, err] = await to(
    requestPlatform<{
      code: number;
      message: string;
      data: ITeslaRegisterPageConfigData;
    }>('/node/activity/ticket/config?id=tesla_register_page_config', 'GET', {}),
  );
  if (err) {
    throw new NetworkError({
      code: err.status,
      message: $t('系统繁忙，请稍后重试'),
      tag: 'getTeslaRegisterPageConfigError',
    });
  }
  const { code, message, data } = respData;
  if (code !== 0) {
    throw new NetworkError({ code, message, tag: 'getTeslaRegisterPageConfigError' });
  }
  return data;
}

// 查看用户贷款状态及活动期间提款金额
export async function CheckLoanStatus(params: ICheckLoanStatusReq): Promise<ICheckLoanStatusResp> {
  const { getT } = i18n;
  const $t = getT();
  const [respData, err] = await to(
    requestPlatform<{
      code: number;
      message: string;
      data: ICheckLoanStatusResp;
    }>('/node/loan/carOwnerRight/checkLoanStatus', 'GET', params),
  );
  if (err) {
    throw new NetworkError({
      code: err.status,
      message: $t('系统繁忙，请稍后重试'),
      tag: 'checkLoanStatusError',
    });
  }
  const { code, message, data } = respData;
  if (code !== 0) {
    throw new NetworkError({ code, message, tag: 'checkLoanStatusError' });
  }
  return data;
}

// 查看用户贷款状态及活动期间提款金额
export async function CheckCarOwnerRight(params: ICheckCarOwnerRightReq): Promise<ICheckLoanStatusResp> {
  const { getT } = i18n;
  const $t = getT();
  const [respData, err] = await to(
    requestPlatform<{
      code: number;
      message: string;
      data: ICheckLoanStatusResp;
    }>('/node/loan/carOwnerRight/checkCarOwnerRight', 'GET', params),
  );
  if (err) {
    throw new NetworkError({
      code: err.status,
      message: $t('系统繁忙，请稍后重试'),
      tag: 'checkCarOwnerRightError',
    });
  }
  const { code, message, data } = respData;
  if (code !== 0) {
    throw new NetworkError({ code, message, tag: 'checkCarOwnerRightError' });
  }
  return data;
}

// 获取车主品牌信息
export async function getBrandOptions(): Promise<IBrandListData> {
  const { getT } = i18n;
  const $t = getT();
  const [respData, err] = await to(
    requestPlatform<{
      code: number;
      message: string;
      data: IBrandListData;
    }>('/node/loan/carOwner/carBrandOptions'),
  );
  if (err) {
    throw new NetworkError({
      code: err.status,
      message: $t('系统繁忙，请稍后重试'),
      tag: 'getBrandOptionsError',
    });
  }
  const { code, message, data } = respData;
  if (code !== 0) {
    throw new NetworkError({ code, message, tag: 'getBrandOptionsProblem' });
  }
  return data;
}

// 检查是否非tesla白名单以及是否电车
export async function CheckNoTeslaWhiteAndIsElectricCar(): Promise<ICheckNoTeslaWhiteAndIsElectricCarResp> {
  const { getT } = i18n;
  const $t = getT();
  const [respData, err] = await to(
    requestPlatform<{
      code: number;
      message: string;
      data: ICheckNoTeslaWhiteAndIsElectricCarResp;
    }>('/node/loan/carOwner/checkNoTeslaWhiteAndIsElectricCar', 'GET'),
  );
  if (err) {
    throw new NetworkError({
      code: err.status,
      message: $t('系统繁忙，请稍后重试'),
      tag: 'checkNoTeslaWhiteAndIsElectricCarError',
    });
  }
  const { code, message, data } = respData;
  if (code !== 0) {
    throw new NetworkError({ code, message, tag: 'checkNoTeslaWhiteAndIsElectricCarError' });
  }
  return data;
}

export async function checkTeslaWhiteAndOwnerInfo(): Promise<ICheckTeslaWhiteAndOwnerInfoData> {
  const { getT } = i18n;
  const $t = getT();
  const [respData, err] = await to(
    requestPlatform<{
      code: number;
      message: string;
      data: ICheckTeslaWhiteAndOwnerInfoData;
    }>('/node/loan/carOwner/checkTeslaWhiteAndOwnerInfo', 'GET'),
  );
  if (err) {
    throw new NetworkError({
      code: err.status,
      message: $t('系统繁忙，请稍后重试'),
      tag: 'checkNoTeslaWhiteAndIsElectricCarError',
    });
  }

  const { code, message, data } = respData;
  if (code !== 0) {
    throw new NetworkError({ code, message, tag: 'checkNoTeslaWhiteAndIsElectricCarError' });
  }
  return data;
}

/**
 * 活动里面涉及多语言的Key
 */
export type IKeyWalletLoanAct =
  | 'backImg'
  | 'applyText'
  | 'applyImg'
  | 'ftImg'
  | 'adTitle'
  | 'productTitle'
  | 'shareContent'
  | 'shareTitle';

type IWalletLoanActLang = {
  [index in `${IKeyWalletLoanAct}-${ILanguageRsp}`]: { value: string };
};

type IWalletLoanActAdImg = {
  /**
   * 广告图多语言图片地址
   */
  [index in `adImg-${number}-${ILanguageRsp}`]: { value: string };
};

export interface IWalletLoanActConfig extends IWalletLoanActLang, IWalletLoanActAdImg {
  /**
   * 广告图外跳链接
   */
  [index: `adImg-link-${number}`]: { value: string };
  /**
   * 底部活动条款与细则链接
   */
  'ftTerms-link': { value: string };
  shareLink: { value: string };
  shareIcon: { value: string };
  hideTag: { value: string };
  showTeslaRightOverview: { value: string };
}

/**
 * 获取易借钱包、APP渠道的3个贷款产品品宣页页面配置
 * 配置路径: Xboss => MMS营销管理系统 => 运营管理中心 => 运营活动配置(新版) => key = walletLoanActPage npploanActPage teslaLoanActPage installmentLoanActPage
 */
export async function getLoanActConfig(id: string) {
  const { getT } = i18n;
  const $t = getT();
  const [respData, err] = await to(
    requestPlatform<{
      code: number;
      message: string;
      data: {
        /**
         * 活动配置开始时间
         * @example 1661936021000
         */
        start_time: number;
        /**
         * 活动配置结束时间
         * @example 1661705616000
         */
        end_time: number;
        ext_info: string;
      };
    }>(`/node/activity/ticket/config?id=${id}`, 'GET', {}),
  );
  if (err) {
    throw new NetworkError({
      code: err.status,
      message: $t('系统繁忙，请稍后重试'),
      tag: 'GetLoanActConfigError',
    });
  }
  const { code, message, data } = respData;

  if (code !== 0) {
    throw new NetworkError({ code, message, tag: 'GetLoanActConfigError' });
  }

  const configsAct = JSON.parse(data.ext_info) as IWalletLoanActConfig;

  // getServerTime 的返回需要乘以 1000 才能与接口的时间戳对齐
  const now = getServerTime() * 1000;

  const isTimeValid = data.start_time < now && data.end_time > now;

  /**
   * 通过多语言读取页面配置
   * 配置key 举例 backImg-zh-CN
   */
  function getConfigVal(key: keyof IWalletLoanActConfig) {
    if (configsAct) {
      return configsAct[key] ? configsAct[key].value : '';
    }
    return '';
  }

  /**
   * 通过多语言读取页面配置
   * 配置key 举例 backImg-zh-CN
   */
  function getConfigLang(key: IKeyWalletLoanAct, lang: ILanguageRsp) {
    return getConfigVal(`${key}-${lang}`);
  }
  return { ...configsAct, isTimeValid, getConfigVal, getConfigLang };
}

// 获取贷款业务配置
export async function GetLoanConfigList<T>(key: string, filePath?: string): Promise<T> {
  const { getT } = i18n;
  const $t = getT();
  const [respData, err] = await to(
    requestPlatform<{
      code: number;
      message: string;
      data: T;
    }>('/node/loan/loanConfig/queryConfigList', 'GET', { key, filePath }),
  );
  if (err) {
    throw new NetworkError({
      code: err.status,
      message: $t('系统繁忙，请稍后重试'),
      tag: 'queryConfigListError',
    });
  }
  const { code, message, data } = respData;
  if (code !== 0) {
    throw new NetworkError({ code, message, tag: 'queryConfigListError' });
  }
  return data;
}

// 获取运营配置
export async function getConfigCommon<T>(id: string) {
  const { getT } = i18n;
  const $t = getT();
  const [respData, err] = await to(
    requestPlatform<{
      code: number;
      message: string;
      data: {
        start_time: number;
        end_time: number;
        state: number;
        ext_info: string;
        name: string;
        activity_no_list?: {activity_no: string}[]
      };
    }>('/node/activity/ticket/config', 'GET', { id }),
  );
  if (err) {
    throw new NetworkError({
      code: err.status,
      message: $t('系统繁忙，请稍后重试'),
      tag: 'getConfigCommonConfigError',
    });
  }

  const { code, message, data } = respData;
  console.log(data, 123456789);
  if (code !== 0) {
    throw new NetworkError({ code, message, tag: 'getConfigCommonPro' });
  }

  return {
    startTime: data.start_time,
    endTime: data.end_time,
    state: data.state,
    extInfo: JSON.parse(data.ext_info) as T,
    name: data.name,
    activityNoList: data.activity_no_list?.map(item => item.activity_no) || []
  };
}
